import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  RiDashboardLine,
  RiMessage2Line,
  RiFileTextLine,
  RiSettings4Line,
  RiMenuFoldLine,
  RiMenuUnfoldLine,
  RiBarChart2Line,
  RiTeamLine,
  RiCustomerService2Line,
} from "react-icons/ri";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuSections = [
    {
      title: "Main",
      items: [
        {
          path: "/",
          icon: RiDashboardLine,
          label: "Dashboard",
        },
      ],
    },
    {
      title: "Services",
      items: [
        {
          path: "/billing",
          icon: RiFileTextLine,
          label: "Billing & Invoices",
        },
        {
          path: "/marketing-services",
          icon: RiMessage2Line,
          label: "Marketing Services",
          // badge: "New",
          badgeColor: "bg-green-500",
        },
      ],
    },
    {
      title: "Management",
      items: [
        {
          path: "/customers",
          icon: RiTeamLine,
          label: "Customers",
        },
        {
          path: "/reports",
          icon: RiBarChart2Line,
          label: "Reports",
        },
      ],
    },
    {
      title: "System",
      items: [
        {
          path: "/settings",
          icon: RiSettings4Line,
          label: "Settings",
        },
        {
          path: "/support",
          icon: RiCustomerService2Line,
          label: "Support",
        },
      ],
    },
  ];

  return (
    <aside
      className={`bg-white border-r border-gray-200 flex flex-col transition-[width] duration-300 ease-in-out overflow-x-hidden ${
        isCollapsed ? "w-16" : "w-64"
      }`}
    >
      {/* Logo and Collapse Button */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-100">
        <div
          className={`overflow-hidden transition-[width] duration-300 ease-in-out ${
            isCollapsed ? "w-0" : "w-36"
          }`}
        >
          <h1 className="font-bold text-2xl text-primary truncate">
            Invoicify
          </h1>
        </div>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-600"
          title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
        >
          {isCollapsed ? (
            <RiMenuUnfoldLine className="w-5 h-5" />
          ) : (
            <RiMenuFoldLine className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 overflow-y-auto overflow-x-hidden py-4 px-2">
        {menuSections.map((section, index) => (
          <div key={section.title} className={index !== 0 ? "mt-6" : ""}>
            {!isCollapsed && (
              <h2 className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
                {section.title}
              </h2>
            )}
            <div className="space-y-1">
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center px-4 py-2.5 text-gray-700 hover:bg-gray-100 group relative transition-all duration-200 ${
                      isActive
                        ? "bg-primary-50 text-primary-600 border-r-4 border-primary-600"
                        : ""
                    }`
                  }
                >
                  <div className="flex items-center">
                    <item.icon
                      className={`w-5 h-5 flex-shrink-0 ${
                        isCollapsed ? "" : "mr-3"
                      }`}
                    />
                    <span
                      className={`whitespace-nowrap transition-all duration-300 ${
                        isCollapsed ? "w-0 opacity-0" : "w-auto opacity-100"
                      }`}
                    >
                      {item.label}
                    </span>
                  </div>
                  {!isCollapsed && item.badge && (
                    <span
                      className={`ml-auto px-2 py-0.5 text-xs font-medium text-white rounded-full ${item.badgeColor}`}
                    >
                      {item.badge}
                    </span>
                  )}
                  {isCollapsed && (
                    <div className="absolute left-full ml-2 hidden group-hover:block">
                      <div className="bg-gray-800 text-white text-sm py-2 px-4 rounded-md whitespace-nowrap">
                        {item.label}
                        {item.badge && (
                          <span
                            className={`ml-2 px-2 py-0.5 text-xs font-medium rounded-full ${item.badgeColor}`}
                          >
                            {item.badge}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* User Profile Section */}
      <div className="border-t border-gray-100 p-4">
        <div className="flex items-center">
          <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 flex-shrink-0">
            <span className="text-sm font-medium">JD</span>
          </div>
          <div
            className={`ml-3 transition-all duration-300 overflow-hidden ${
              isCollapsed ? "w-0 opacity-0" : "w-auto opacity-100"
            }`}
          >
            <h3 className="text-sm font-medium text-gray-700 truncate">
              John Doe
            </h3>
            <p className="text-xs text-gray-500 truncate">Administrator</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
